"use client"

import type { LucideIcon } from "lucide-react"

interface DashboardStatCardProps {
  icon: LucideIcon
  label: string
  value: string
  iconBgColor: string
  iconColor: string
}

export function DashboardStatCard({ icon: Icon, label, value, iconBgColor, iconColor }: DashboardStatCardProps) {
  return (
    <div className="items-center gap-4">
    <div className="bg-slate-100 relative p-6 rounded-2xl flex items-center gap-4">
      <p className={`${iconColor} absolute  top-0 text-sm font-bold `}>{label}</p>
      <div className={`${iconBgColor} p-3 rounded-xl`}>
        <Icon className={`${iconColor} w-8 h-8`} />
      </div>
      <div>
        {/* <p className="text-gray-600 text-sm">{label}</p> */}
        <p className="font-bold text-xl text-gray-800">{value}</p>
      </div>
    </div>
    </div>
  )
}
